import { NavController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the NavProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NavProvider {

  constructor(
      private router: NavController
  )
  {

  }

  goTo(url)
  {
      this.router.push(url);
  }

}



// WEBPACK FOOTER //
// ./src/providers/nav/nav.ts